export default __webpack_public_path__ + "static/media/ge400.d1decafd.png";